(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('SectorClinicName', SectorClinicName);

    SectorClinicName.$inject = ['$resource'];

    function SectorClinicName ($resource) {
        var resourceUrl =  'api/sector-clinic-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
